define('GameDayCore/GDModel/GameItem/GameItem',['require','exports','module','../storage/ModelCache','../../GDControl/TfsManager/TfsManager','message-service/message-service','extant/extant','../../GDUtil/window/Logg','../ValueObjects/Players/PlayerModel','../load/manager/HeartbeatItem','../load/manager/PassiveRequest','gameday-index-enums/enums/baseball/GIDDecoder','../enums/events/EventTypes','../load/manager/GumboHeartbeat','../../GDUtil/resources/GDConfig'],function(require,exports,module) {
    var ModelCache = require("../storage/ModelCache"),
        TfsManager = require("../../GDControl/TfsManager/TfsManager"),
        MessageService = require("message-service/message-service"),
        exists = require("extant/extant"),
        logg = require("../../GDUtil/window/Logg"),
        PlayerModel = require("../ValueObjects/Players/PlayerModel"),
        HeartbeatItem = require("../load/manager/HeartbeatItem"),
        PassiveRequestItem = require("../load/manager/PassiveRequest"),
        GameId = require("gameday-index-enums/enums/baseball/GIDDecoder"),
        EventTypes = require("../enums/events/EventTypes"),
        GumboHeartbeat = require("../load/manager/GumboHeartbeat"),
        GDConfig = require("../../GDUtil/resources/GDConfig");


    function setMode(config) {
        if (config.initProps.gumboMode === true) {
            return "gumbo";
        } else {
            return (config.passiveMode === true) ? "passive" : "heartbeat";
        }
    }

    /**
     * Class GameItem
     * @param gameID {String}
     * @returns {Object}
     *
     * The Manager object of an individual game. It contains some core details about the game (via the GID object)
     * and provides a pathway to the gameData / heartbeat etc associated with that game
     */
    function GameItem(gameID) {
        var that = this;
		this.gid = new GameId(gameID);
        this.gumboPulse = null;
        this.heartbeat = null;
        this.passiveLoader = null;
        this.gameID = gameID;

         MessageService.one(EventTypes.INIT_DATA_LOADED, function(){
            that.initialized = true;
            logg.log("dispatching game ready");
            MessageService.publish(EventTypes.GAME_INITIALIZED);
         });
    }

	// mixin public references to internal functions
	GameItem.prototype = {
        initialized : false,
        /**
         * Function init
         *
         * Activates the game item.
         */
        init : function(listenFunc, dispatchFunc) {
            if(this.initilized && exists(this.heartbeatItem)){
                this.heartbeatItem.start()
                return;
            }
            this.hbMode = setMode(GDConfig);
            switch (this.hbMode) {
                case "gumbo":
                    this.gumboPulse = new GumboHeartbeat(this.gameID, this);
                    this.gumboPulse.init();
                    break;
                case "passive":
                    this.passiveLoader = new PassiveRequestItem(this.gameID,this);
                    this.passiveLoader.loadGameData();
                    break;
                case "heartbeat":
                default:
                    this.heartbeat = new HeartbeatItem(this.gameID, this);
                    this.heartbeat.init();
                    break;
            }

            this.heartbeatItem = this.hbMonitor = this.gumboPulse || this.heartbeat || this.passiveLoader;
        },
        /**
         * Function getGameData
         * @param flavor (*} the data you want as string, comma-delineated string, array or object
         * @returns {Object} a game data object with each requested datasource as an attribute on the root obj
         *
         * retrieves the game data for this game (as-is) from the model cache.
         * calling with no params returns the whole shebang
         */
		getGameData: function(flavor) {
            return ModelCache.retrieveGameData(this.gameID, flavor);
        },
        /**
         * Function expireGameData
         * @param flavor (*} the data you want to expire as string, comma-delineated string, array or object
         *
         * Expires data from the ModelCache's backing store to flag it for a refresh
         */
        expireGameData: function(flavor) {
            ModelCache.expireDatasources(this.gameID, flavor);
        },
        /**
         * Function requestGameData
         * @param flavor {*} the data you want as string, comma-delineated string, array or object
         * @param upID {String} the event id the for the results of this request to transport on
         * @param params {Object} optional additional name-value pairs for the datasource Manager
         *
         * this tells the model cache to check if the data is either loaded or fresh enough
         * it will Execute any necessary loads, and dispatch the results over the unique update id passed
         */
        requestGameData : function(flavor, upID, params){
            ModelCache.getFreshGameData(this.gameID, flavor, upID, params, false);
        },

		getFreshGameData: function (flavor, upID, params) {
            ModelCache.getFreshGameData(this.gameID, flavor, upID, params, true);
        },
		/**
         * Function getGameParams
         * @param overrides {Object} mix-ins for additional featurs
         * @returns {Object} default params + tfs host / time code (when applicable) passed mix-ins
         *
         * This provides an object of name-value pairs for most items going through datasource Manager
         */
        addGameParams : function(overrides) {
            var gid = this.gid,
                params = {
                    "yyyy"      : gid.year,
                    "mm"        : gid.month,
                    "dd"        : gid.day,
                    "gid"       : gid.gid_path,
                    "sportcode" : gid.home_sport_code,
                    tfshost     : TfsManager.getTfsHost(),
                    timecode    : TfsManager.getCurrentTimecode()
                };

            return $.extend(params, overrides);
        },
        hbMode: "heartbeat",
		pauseHeartbeat: function() {
            this.hbMonitor.pause()
        },
		stopHeartbeat: function() {
            this.hbMonitor.stop()
        },
		unStopHeartbeat: function() {
            this.hbMonitor.start()
        },
		startHeartbeat: function() {
            this.hbMonitor.start()
        },
        executePassiveLoad: function() {
            if(this.hbMode !== "passive") {
                this.hbMonitor.start();
            } else {
                this.hbMonitor.loadGameData();
            }
        },
		active: function() {
            return this.hbMonitor.isActive();
        },
		getPlayerSnapshot: function(playerID, playerType) {
            return new PlayerModel(playerID, ( typeof playerType !== "string") ? "b" : playerType, this.gameID);
        }
	};

    return GameItem;
});


